<template>
    <v-row justify="center">
    <v-dialog v-model="mostrar" persistent max-width="80%">
      
      <v-card>
        <v-card-title>
          <span class="headline">Asignar Maxisaco</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <v-row>
                  <v-col>
                  <h3>Lote</h3>
                  </v-col>
                  <v-col style="text-align:right;">
                      <v-btn dark color="green light-darken-1" @click="abrir_modal_lote">Crear Lote</v-btn>
                  </v-col>
              </v-row>
              <v-row>
              <v-divider></v-divider>
              </v-row>
              <v-row>
                  <v-progress-linear
                    v-if="cargando_lote_jumbo"
                    indeterminate
                    color="green"
                  ></v-progress-linear>
              </v-row>
              <v-row>
                <v-alert
                    :value="alert"
                    color="orange"
                    dark
                    border="top"
                    icon="warning"
                    transition="scale-transition"
                    class="mt-4"
                    >
                    {{mensaje_alert}}
                    <v-btn icon @click="alert = false">
                        <v-icon>highlight_off</v-icon>
                    </v-btn>
                </v-alert>
              </v-row>

              <v-row>
                  <v-col>
                      <v-text-field type="text" :label="`N° Lote`" v-model="lote"></v-text-field>
                  </v-col>
                  <v-col>
                      <v-text-field v-model="numero_jumbo" label="Maxisaco N°"></v-text-field>
                  </v-col>
                  <v-col>
                      <v-text-field v-model="peso" label="Peso (Kg)"></v-text-field>
                  </v-col>
              </v-row>

            <v-expansion-panels>
                <v-expansion-panel
                >
                    <v-expansion-panel-header>
                        Lotes Abiertos / Maxisacos sin Asignar
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <v-row>
                        <v-col>
                            <v-card>
                                <v-card-text>
                                    Lotes Abiertos
                                </v-card-text>
                                <v-simple-table dense fixed-header height="300px">
                                    <!-- <template v-slot:default> -->
                                        <thead>
                                            <tr>
                                                <th class="text-center blue">Lote</th>
                                                <th class="text-center blue">Ultimo Maxisaco</th>
                                                <th class="text-center blue">Total (Kg)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in lotes_abiertos" :key="item.id" @click="setear_lote(item)">
                                            <td class="text-center">{{ item.nombre_lote }}</td>
                                            <td class="text-center">{{ item.ultimo_jumbo }}</td>
                                            <td class="text-center">{{ item.total_kg }}</td>
                                            </tr>
                                        </tbody>
                                    <!-- </template> -->
                                </v-simple-table>
                            </v-card>
                        </v-col>
                        <v-col>
                        <v-card>
                            <v-card-text>
                                    Maxisacos Sin Asignar
                                </v-card-text>
                                <v-simple-table dense fixed-header height="300px">
                                        <!-- <template v-slot:default> -->
                                            <thead>
                                                <tr>
                                                    <th class="text-center blue">Lote</th>
                                                    <th class="text-center blue">Maxisaco N°</th>
                                                    <th class="text-center blue">Peso (kg)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in jumbos_sin_asignar" :key="item.id" @click="setear_jumbo_sin_asignar(item,)">
                                                <td class="text-center">{{ item.nombre_lote }}</td>
                                                <td class="text-center">{{ item.nro_jumbo }}</td>
                                                <td class="text-center">{{ item.peso }}</td>
                                                </tr>
                                            </tbody>
                                        <!-- </template> -->
                                </v-simple-table>
                        </v-card>
                    </v-col>
                    </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

               <!-- tabla de lotes abiertos -->
               
                <!-- tabla de lotes abiertos -->

              

            <!-- descomentar en caso de volver a usar envio a reproceso -->

              <!-- <v-row>
                  <v-col>
                    <h3>Viene de Reproceso 
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon color="grey lighten-1">help</v-icon>
                                </v-btn>
                            </template>
                            <span>Se debe utilizar para indicar si el "Jumbo" que esta creando proviene de otro Jumbo</span>
                        </v-tooltip>
                    </h3>
                  </v-col>
            </v-row>
            <v-row>
                  <v-divider></v-divider>
            </v-row> -->
            
            <!-- <v-row v-if="lote_reproceso_antiguo != ''">
                        <v-col>
                            <v-switch
                            v-model="descartar_reproceso"
                            :label="`No Proviene de Jumbo`"
                            ></v-switch>
                        </v-col>
                        <v-col>
                            <v-chip
                            class="ma-2"
                            color="orange darken-3"
                            label
                            text-color="white"
                            >
                            Proviene   
                            <v-icon left>arrow_right_alt</v-icon>
                            Lote:{{lote_reproceso_antiguo}}  N° Jumbo: {{jumbo_reproceso_antiguo}}
                            </v-chip>
                        </v-col>
            </v-row> -->

            <!-- <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-switch
                v-model="reproceso"
                :label="`Reproceso o Repaso`"
                @change="cargarReproceso"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                  <span v-if="mostrar_loader">
                      <v-progress-linear
                    indeterminate
                    color="green"
                    ></v-progress-linear> {{mensaje_loader}}
                  </span>
              </v-col>
            </v-row> -->
            <!-- descomentar en caso de volver a usar envio a reproceso -->
            
            <v-row>
                <v-col>
                    <v-alert
                    v-if="reproceso"
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                    >
                    Si no encuentra el maxisaco, es porque no esta para repaso o reproceso! <v-btn dark color="orange darken-1" @click="abrir_modal_repasar_jumbo()">Reprocesar</v-btn>
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-autocomplete v-if="reproceso"
                                        v-model="lote_reproceso"
                                        :items="lotes_de_reproceso"
                                        item-text="nombre_lote"
                                        item-value="id"
                                        :label="`Seleccione Lote`"
                                        color="blue darken-3"
                                        persistent-hint
                                        return-object
                                        dense
                                        @change="actualizar_jumbos_reproceso"
                    ></v-autocomplete>
                </v-col>
                <v-col>
                    <v-autocomplete v-if="reproceso"
                    v-model="jumbo_reproceso"
                    :items="jumbos_select"
                    item-text="nro_jumbo"
                    item-value="id"
                    :label="`Seleccione Maxisaco N°`"
                    color="blue darken-3"
                    persistent-hint
                    return-object
                    dense></v-autocomplete>
                </v-col>
            </v-row>
            
          </v-container>
          <small>*Campos Requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="blue darken-1"  @click="limpiar">Cancelar</v-btn>
          <v-btn dark color="green darken-1"  @click="crearJumbo" :disabled="!activar_guardar">Guardar</v-btn>
        </v-card-actions>
      </v-card>


      <!-- editar jumbo asignado -->
      <!-- <v-card v-if="!crear">
          <v-card-title>Actualizar Jumbo Asignado</v-card-title>
          <v-card-text>
              <v-container>
                  <v-row>
                      <v-col>

                      </v-col>
                  </v-row>
              </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1"  @click="limpiar">Cancelar</v-btn>
            <v-btn dark color="green darken-1"  @click="editarJumbo">Actualizar</v-btn>
          </v-card-actions>
      </v-card> -->
      <!-- editar jumbo asignado -->

    </v-dialog>


    <!-- modal lote -->
    <!-- <modal-lote></modal-lote> -->
    <!-- modal lote -->

    <!-- modal lotes -->
    <modal-lotes @realizado="cargar_lotes_abiertos"></modal-lotes>
    <!-- modal lotes -->

    <!-- modal jumbo reproceso -->
    <modal-jumbo-reproceso></modal-jumbo-reproceso>
    <!-- modal jumbo reproceso -->

  </v-row>

  
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
// import Modal_Lote from '@/components/shared/Modal_Lote.vue';
import Modal_Lotes from '@/components/shared/Modal_Lotes.vue';

import Modal_Jumbo_Reproceso from './Modal_Jumbo_Reproceso.vue';
export default {
    data:()=>({
        mostrar:false,
        mostrar_loader:false,
        mensaje_loader:'',
        cargando_lote_jumbo:false,
        reproceso:false,
        registro:{},
        resultado_original:{},
        tipo_lote:'normal',
        lote:'',
        numero_jumbo:'',
        peso:1250,
        lote_reproceso:'',
        lote_reproceso_antiguo:'',
        lotes_de_reproceso:[],
        lotes_abiertos:[],
        jumbo_reproceso:'',
        jumbo_reproceso_antiguo:'',
        jumbos_de_reproceso:[],
        jumbos_sin_asignar:[],
        jumbos_select:[],
        ultimo_lote:{},
        ultimo_jumbo:{
            nro_jumbo:0
        },
        mensaje_alert:'',
        alert:false,
        crear:true,
        descartar_reproceso:false,
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_jumbo');
        Event.$off('nuevo_lote');
        Event.$off('actualizar_jumbos_reproceso');
    },
    mounted() {
        Event.$on('abrir_modal_jumbo',async (registro,accion)=>{
            await this.limpiar();
            this.cargar_lotes_abiertos();
            if(accion == 'crear'){
                this.crear = true;
            }else if(accion == 'editar'){
                this.crear = false;
                //cargar la informacion del resultado análisis
                await this.cargar_informacion_registro(registro.id_registro);
                // console.log('registro a editar',registro);
            }
            this.registro = registro;
            this.mostrar = true;
            console.log('peso jumbo',this.peso);
            // this.cargar_lote();
            // this.cargar_lotes_reproceso();
        });

        Event.$on('nuevo_lote',(lote)=>{
            this.cargar_lotes_abiertos();
        });

        Event.$on('actualizar_jumbos_reproceso',()=>{
            this.cargar_lotes_reproceso();
        });
    },
    methods: {

        async cargar_lotes_abiertos(){
            this.cargando_lote_jumbo = true;
            this.lotes_abiertos = [];
            this.jumbos_sin_asignar = [];
            let url = `${this.base_url}lote/abiertos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.lotes_abiertos = response.data.data;
                this.cargando_lote_jumbo = false;
                this.cargar_jumbos_sin_asignar();
            }).catch((error)=>{
                console.log('error',error);
                this.cargando_lote_jumbo = false;
            });
        },

        async cargar_jumbos_sin_asignar(){
            this.cargando_lote_jumbo = true;
            let url = `${this.base_url}jumbo/sin_asignar`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.jumbos_sin_asignar = response.data.data;
                this.cargando_lote_jumbo = false;
            }).catch((error)=>{
                console.log('error',error);
                this.cargando_lote_jumbo = false;
            });
        },

        setear_lote(lote){
            // console.log('lote_seleccionado',lote);
            this.lote = lote.nombre_lote;
            if(lote.ultimo_jumbo==null){
                this.numero_jumbo = 1;
                // console.log('entro a null');
            }else{
                this.numero_jumbo = lote.ultimo_jumbo+1;
                // console.log('NOOOO entro a null');
            }
            // this.peso = 0;
        },

        setear_jumbo_sin_asignar(jumbo){
            this.lote = jumbo.nombre_lote;
            this.numero_jumbo = jumbo.nro_jumbo;
            this.peso = jumbo.peso;
        },

        cargarReproceso(){
            if(this.reproceso){
                this.cargar_lotes_reproceso();
            }else{
                this.lote_reproceso = '';
                this.jumbo_reproceso = '';
            }
        },

        async cargar_informacion_registro(id){
            //this.mostrarLoading('Cargando Registro...');
            this.mostrarLoading({titulo:'Cargando Registro...',color:'green'})

            
            let url = `${this.base_url}resultados/${id}`;
            await this.axios.get(url,this.headers).then((response)=>{
                
                this.resultado_original = response.data.data;
                console.log('resultado analisis a editar',this.resultado_original);
                this.lote = this.resultado_original.jumbo.lote.nombre_lote;
                this.numero_jumbo = this.resultado_original.jumbo.nro_jumbo;
                this.peso = this.resultado_original.jumbo.peso;
                if(this.resultado_original.jumbo.viene_del_jumbo != null){
                    //proviene de un jumbo
                    this.lote_reproceso_antiguo = this.resultado_original.jumbo.proveniente_de.lote.nombre_lote;
                    this.jumbo_reproceso_antiguo = this.resultado_original.jumbo.proveniente_de.nro_jumbo;
                    this.cargar_lotes_reproceso();
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async cargar_lotes_reproceso(){
            this.mensaje_loader = 'Cargando Lotes con Maxisacos Enviados a Reproceso o Repaso...'
            this.mostrar_loader = true;
            let url = `${this.base_url}lotes/jumbos/repaso`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.lotes_de_reproceso = response.data.lotes;
                this.jumbos_de_reproceso = response.data.jumbos;
                for(let i=0; i<this.jumbos_de_reproceso.length; i++){
                    let mjumbo = this.jumbos_de_reproceso[i];
                    if(mjumbo.lote.nombre_lote == this.lote && mjumbo.nro_jumbo == this.numero_jumbo){
                        this.jumbos_de_reproceso.splice(i, 1);
                    }
                }
                this.mostrar_loader = false;
                // console.log('lotes',this.lotes_de_reproceso);
               // console.log('jumbos',this.jumbos_de_reproceso);

            }).catch((error)=>{
                console.log('error',error);
                this.mostrar_loader = false;
            });
        },

        async cargar_lote(){
            this.cargando_lote_jumbo = true;
            let url = '';
            if(this.tipo_lote == 'con_restriccion'){
                //cargar el último lote con restricción
                url = `${this.base_url}lote/ultimo/restriccion`;
            }else if(this.tipo_lote == 'normal'){
                //cargar último lote normal
                url = `${this.base_url}lote/ultimo/normal`;

            }

            await this.axios.get(url,this.headers).then((response)=>{
                this.ultimo_lote = response.data.ultimo_lote;
                if(response.data.ultimo_jumbo==null){
                    // console.log('entro');
                    this.ultimo_jumbo.nro_jumbo=0;
                }else{
                    this.ultimo_jumbo = response.data.ultimo_jumbo;
                }
                
                this.lote = this.ultimo_lote.nombre_lote;
                
                if(this.ultimo_jumbo.nro_jumbo == 40 && this.tipo_lote == 'normal'){
                    this.numero_jumbo = 1;
                    this.lote=Number(this.lote)+1;
                }

                if(this.ultimo_jumbo.nro_jumbo < 40 && this.tipo_lote == 'normal'){
                    this.numero_jumbo= this.ultimo_jumbo.nro_jumbo+1;
                }

                if(this.tipo_lote == 'con_restriccion'){
                    this.numero_jumbo = this.ultimo_jumbo.nro_jumbo+1;
                }
                this.cargando_lote_jumbo = false;

            }).catch((error)=>{
                console.log('error',error);
                this.cargando_lote_jumbo = false;
            });
            // console.log('tipo de lote',this.tipo_lote);
        },

        async actualizar_jumbos_reproceso(){
            this.mensaje_loader = 'Cargando Maxisacos...';
            this.mostrar_loader = true;
            this.jumbos_select = [];
            await this.jumbos_de_reproceso.forEach(jumbo => {
                // console.log('jumbo_actual',jumbo);
                if(jumbo.lotes_id == this.lote_reproceso.id){
                    this.jumbos_select.push(jumbo);
                }
            });
            // console.log('jumbos select',this.jumbos_select);
            this.mostrar_loader = false;
            // console.log('lote reproceso',this.lote_reproceso);
        },

        async consultar_jumbo(lote_id){
            this.cargando_lote_jumbo = true;
            let jumbo = null;
            let url = `${this.base_url}jumbo/lotes_id/${lote_id}/nro_jumbo/${this.numero_jumbo}`;
            await this.axios.get(url,this.headers).then((response)=>{
                    console.log('jumbo',response.data.jumbo);
                    jumbo = response.data.jumbo;
                }).catch((error)=>{
                    console.log('error',error);
            });
            return jumbo;
        },

        async consultar_jumbo_2(){
            this.cargando_lote_jumbo = true;
            let jumbo = null;
            //verificar que exista el lote, de lo contrario se debe crear
            let lote = await this.consultar_lote();
            if(lote!=null){
                this.cargando_lote_jumbo = true;
                let url = `${this.base_url}jumbo/lotes_id/${lote.id}/nro_jumbo/${this.numero_jumbo}`;
                await this.axios.get(url,this.headers).then((response)=>{
                    console.log('Maxisaco',response.data.jumbo);
                    jumbo = response.data.jumbo;
                }).catch((error)=>{
                    console.log('error',error);
                });

                if(jumbo==null){
                    //no existe el jumbo
                    return true;
                }else{
                    //ya existe el jumbo
                    this.mensaje_alert = `El Maxisaco N° ${this.numero_jumbo} del Lote ${this.lote} Ya Existe`;
                    this.alert = true;
                    return false;
                }
            }else{
                this.mensaje_alert = 'El Lote ingresado no existe, debe crearlo';
                this.alert = true;
                return false;
            }
        },

        async crearJumbo(){
            this.cargando_lote_jumbo = true;

            //comprobar el lote
            let lote = await this.consultar_lote();
            if(lote!=null){
                //si existe el lote
                //console.log(lote);return;
                //comprobar que no exista el jumbo con el numero y lote seleccionado
                let jumbo = await this.consultar_jumbo(lote.id);
                
                if(this.crear){
                    //se esta creando un jumbo
                    if(jumbo==null){
                        this.cargando_lote_jumbo = true;
                        let body = {
                            lotes_id:lote.id,
                            nro_jumbo:this.numero_jumbo,
                            rechazo_jumbos_id: 0,
                            peso:this.peso
                        };
                        if(this.reproceso){
                            //esta seleccionado que el jumbo viene de reproceso
                            body['viene_del_jumbo']=this.jumbo_reproceso.id;
                        }
                        if(lote.nombre_lote.startsWith('R')){
                            body.rechazo_jumbos_id = 1;
                        }
                        let url = `${this.base_url}jumbos`;
                        // console.log('body_jumbo',body);
                        await this.axios.post(url,body,this.headers).then((response)=>{
                            console.log('Maxisaco creado',response.data.data);
                            this.cargando_lote_jumbo = false;
                            Event.$emit('nuevo_jumbo',response.data.data,this.registro);
                            this.limpiar();
                        }).catch((error)=>{
                            console.log('error',error);
                            this.cargando_lote_jumbo = false;
                        });
                        // console.log('se puede crear');
                    }else{

                        //comprobar si el jumbo esta asignado a un registro
                        let resultado = await this.consultar_resultado_analisis_por_jumbo(jumbo.id);
                        console.log('resultado?existe?',resultado);
                        if(resultado==null){
                            //asignar el id del jumbo al registro
                            
                            if(this.peso != jumbo.peso){
                                //actualizar peso del jumbo ( en caso de que haya cambiado)
                                let body = {
                                    peso:this.peso
                                }
                                await this.actualizar_jumbo(jumbo.id,body);
                            }
                            Event.$emit('actualizar_jumbo',jumbo,this.registro);
                            this.limpiar();
                        }else{
                            //el jumbo esta asignado aun registro
                            console.log('jumbo',jumbo);
                            this.mensaje_alert = `El Maxisaco N°: ${jumbo.nro_jumbo} del Lote: ${jumbo.lote.nombre_lote} ya se encuentra asignado a un registro`;
                            this.cargando_lote_jumbo = false;
                            this.alert = true;
                        }
                        console.log('resultado',resultado);
                    }
                }else{
                    //se esta editando el jumbo de un registro

                    //comprobar si cambio el lote y el jumbo
                    if(this.lote != this.registro.nombre_lote || this.numero_jumbo != this.registro.nro_jumbo){
                        console.log('cambio el lote o el Maxisaco');
                        //comprobar si existe el jumbo
                        if(jumbo==null){
                            //el jumbo no existe, se puede crear
                            this.cargando_lote_jumbo = true;
                            let body = {
                                lotes_id:lote.id,
                                nro_jumbo:this.numero_jumbo,
                                peso:this.peso
                            };
                            if(this.reproceso){
                                //esta seleccionado que el jumbo viene de reproceso
                                body['viene_del_jumbo']=this.jumbo_reproceso.id;
                            }
                            let url = `${this.base_url}jumbos`;
                            // console.log('body_jumbo',body);
                            await this.axios.post(url,body,this.headers).then((response)=>{
                                console.log('jumbo creado',response.data.data);
                                this.cargando_lote_jumbo = false;
                                Event.$emit('nuevo_jumbo',response.data.data,this.registro);
                                this.limpiar();
                            }).catch((error)=>{
                                console.log('error',error);
                                this.cargando_lote_jumbo = false;
                            });
                        }else{
                            //el jumbo existe
                            //comprobar si el jumbo esta asignado a un registro
                            let resultado = await this.consultar_resultado_analisis_por_jumbo(jumbo.id);
                            console.log('resultado?existe?',resultado);
                            if(resultado==null){
                                //asignar el id del jumbo al registro
                                if(this.peso != jumbo.peso){
                                    //actualizar peso del jumbo ( en caso de que haya cambiado)
                                    let body = {
                                        peso:this.peso
                                    }
                                    await this.actualizar_jumbo(jumbo.id,body);
                                }
                                Event.$emit('actualizar_jumbo',jumbo,this.registro);
                                this.limpiar();
                            }else{
                                //el jumbo esta asignado aun registro
                                console.log('jumbo',jumbo);
                                this.mensaje_alert = `El Maxisaco N°: ${jumbo.nro_jumbo} del Lote: ${jumbo.lote.nombre_lote} ya se encuentra asignado a un registro`;
                                this.cargando_lote_jumbo = false;
                                this.alert = true;
                            }
                        }
                    }else{
                        //es el mismo lote y jumbo
                        console.log('es el mismo lote y Maxisaco');
                        let jumbo = await this.consultar_jumbo(lote.id);

                        if(this.peso != jumbo.peso){
                                //actualizar peso del jumbo ( en caso de que haya cambiado)
                                let body = {
                                    peso:this.peso
                                }
                                await this.actualizar_jumbo(jumbo.id,body);
                        }
                        //comprobar si viene de un jumbo el jumbo que se esta editando
                        if(this.registro.proviene_de){
                            console.log('proviene de un jumbo');
                            //comprobar si se selecciono reproceso
                            if(this.reproceso){
                                //comprobar si cambio el jumbo del que proviene
                                if(this.lote_reproceso.nombre_lote != this.lote_reproceso_antiguo || this.jumbo_reproceso.nro_jumbo != this.jumbo_reproceso_antiguo){
                                    console.log('cambio el jumbo del que proviene');
                                    //actualizar el viene_del_jumbo del jumbo del registro actual
                                    // let body = {
                                    //     lotes_id:lote.id,
                                    //     nro_jumbo:this.numero_jumbo,
                                    // };
                                    let body = {};
                                    body['viene_del_jumbo']=this.jumbo_reproceso.id;
                                    let url = `${this.base_url}jumbos/${jumbo.id}`;
                                    // console.log('body_jumbo',body);
                                    await this.axios.put(url,body,this.headers).then((response)=>{
                                        console.log('proviene del jumbo actualizado',response.data.data);
                                        this.cargando_lote_jumbo = false;
                                        Event.$emit('actualizar_jumbo',response.data.data,this.registro);
                                        this.limpiar();
                                    }).catch((error)=>{
                                        console.log('error',error);
                                        this.cargando_lote_jumbo = false;
                                    });
                                }else{
                                    console.log(' no cambio el jumbo del que proviene');
                                    Event.$emit('actualizar_jumbo',jumbo,this.registro);
                                    this.limpiar();
                                }
                            }else{
                                //comprobar si se marco que no proviene de ningun Maxisaco
                                if(this.descartar_reproceso){
                                    //se quito que el Maxisaco viene de otro Maxisaco
                                    let url = `${this.base_url}jumbos/${jumbo.id}`;
                                    let body = {
                                        viene_del_jumbo:null
                                    };
                                    await this.axios.put(url,body,this.headers).then((response)=>{
                                        this.cargando_lote_jumbo = false;
                                        Event.$emit('actualizar_jumbo',response.data.data,this.registro);
                                        this.limpiar();
                                    }).catch((error)=>{
                                        console.log('error',error);
                                        this.cargando_lote_jumbo = false;
                                    });
                                }else{
                                    Event.$emit('actualizar_jumbo',jumbo,this.registro);
                                    this.limpiar();
                                }
                                console.log('no cambio el Maxisaco del que proviene, no se selecciono reproceso');
                            }
                            console.log('lote reproceso seleccionado',this.lote_reproceso);
                            console.log('Maxisaco reproceso seleccionado',this.jumbo_reproceso);

                        }else{
                            //comprobar si se selecciono que proviene de un jumbo
                            console.log('no proviene de un Maxisaco');

                            if(this.reproceso){
                                console.log('el Maxisaco no provenia de otro, pero se actualizo a que proviene de uno');
                                let body = {};
                                body['viene_del_jumbo']=this.jumbo_reproceso.id;
                                let url = `${this.base_url}jumbos/${jumbo.id}`;
                                await this.axios.put(url,body,this.headers).then((response)=>{
                                    console.log('proviene del Maxisaco actualizado',response.data.data);
                                    this.cargando_lote_jumbo = false;
                                    Event.$emit('actualizar_jumbo',response.data.data,this.registro);
                                    this.limpiar();
                                }).catch((error)=>{
                                    console.log('error',error);
                                    this.cargando_lote_jumbo = false;
                                });
                            }else{
                                console.log('emitiendoo...');
                                Event.$emit('actualizar_jumbo',jumbo,this.registro);
                                this.limpiar();
                            }
                        }
                        // console.log('registro',this.registro);
                        // console.log('registro original',this.registro_original);
                    }
                    //1.- comprobar si el lote y y el nro del jumbo es el mismo del registro
                    //2.- si es el mismo pero se actualizo a que viene de reproceso, se debe actualizar el jumbo
                    //3.- si no es el mismo debo comprobar que no exista la combinacion y si no existe se crea
                    //4.- si no es el mismo y el jumbo ya existe, comprobar si esta asignado, en caso contrario actualizar id del jumbo



                }

            }else{
                this.mensaje_alert = 'El Lote ingresado no existe, debe crearlo';
                this.alert = true;
            }
            
        },

        async consultar_resultado_analisis_por_jumbo(id){
            let resultado = null;
            let url = `${this.base_url}resultados/jumbos_id/${id}`;
            await this.axios.get(url,this.headers).then((response)=>{
                resultado = response.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
            return resultado;
        },

        async editarJumbo(){
            console.log('editando');
        },

        async actualizar_jumbo(id,body){
            console.log('entro actualizar jumbo',id,body);
            let url = `${this.base_url}jumbos/${id}`;
            await this.axios.put(url,body,this.headers).then((res)=>{
                console.log('jumbo actualizado',res);
            }).catch((error)=>{
                console.log('error',error);
                
            });
        },

        async consultar_lote(){
            this.cargando_lote_jumbo = true;
            let url = `${this.base_url}lote/nombre_lote/${this.lote}`;
            let lote = null;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta lote',response.data.lote);
                lote = response.data.lote;
                this.cargando_lote_jumbo = false;
            }).catch((error)=>{
                console.log('error',error);
                this.cargando_lote_jumbo = false;
            });
            return lote;
        },

        abrir_modal_lote(){
            // console.log('si llega');
            let conf = {titulo:'Crear Nuevo Lote',tipo_peticion:'POST',materias_primas:[],antioxidantes:[],tipo_lotes:[],antioxidante_nombres:[]};
            this.$emit('abrir_modal_lotes',conf,null);
            // this.mostrar = false;
            // Event.$emit('abrir_modal_lote');
        },

        abrir_modal_repasar_jumbo(){
            Event.$emit('abrir_modal_jumbo_reproceso');
        },

        limpiar(){ 
            this.mensaje_loader = '';
            this.reproceso = false;
            this.tipo_lote = 'normal';
            this.lote = '';
            this.numero_jumbo = '';
            this.peso = 1250;
            this.lote_reproceso = '';
            this.lotes_de_reproceso = [];
            this.jumbo_reproceso = '';
            this.lote_reproceso_antiguo = '';
            this.jumbo_reproceso_antiguo = '';
            this.jumbos_de_reproceso = [];
            this.jumbos_select = [];
            this.ultimo_lote = {};
            this.ultimo_jumbo = {
                nro_jumbo:0
            };
            this.mensaje_alert = '';
            this.alert = false;
            this.mostrar = false;
            this.crear = true;
            this.resultado_original = {};
            this.lotes_abiertos = [];
            this.jumbos_sin_asignar = [];
            this.descartar_reproceso = false;
        
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),
        activar_guardar(){
            let activar = false;
            if(this.lote!=''&&this.numero_jumbo!=''){
                if(this.reproceso == true){
                    if(this.lote_reproceso!='' && this.jumbo_reproceso!=''){
                        activar = true;
                    }
                }else{
                    activar = true;
                }
            }
            return activar;
        }
    },
    components:{
        // 'modal-lote':Modal_Lote,
        'modal-lotes':Modal_Lotes,
        'modal-jumbo-reproceso':Modal_Jumbo_Reproceso
    }
}
</script>